import api from '@/api/axios'
// import Cookies from 'js-cookie';
// import CryptoJS from 'crypto-js';


export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || null,
        user: JSON.parse(localStorage.getItem('user')) || null
    },
    getters: {
        authenticated(state) {
            return state.token && state.user
        },
        user(state) {
            return state.user;
        }
    },
    mutations: {
        SET_TOKEN(state, token) { 
            state.token = token;
            localStorage.setItem('token', token);
        },
        SET_USER(state, data) {
            state.user = data;
            localStorage.setItem('user', JSON.stringify(data));
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        async verifyStatusRegister({ commit, dispatch }, credentials) {
            // eslint-disable-next-line no-debugger
            let response = await api.post('/login/verifyStatusRegister', credentials);
            if(response.status == 200){
                return response;
            }else{
                return response;
            }
        },

        async signIn({ commit, dispatch }, credentials) {
            let response = await api.post('/login', credentials);
            if(response.status == 200){
                dispatch('attemptUser', response.data.data);
                dispatch('attempt', response.data.data.TokenAuth);
            }else{
                commit('SET_TOKEN', null)
                commit('SET_USER', null);
            }
            return response;
        },

        // eslint-disable-next-line no-unused-vars
        async verifyLogin({ commit, dispatch }, credentials) {
            return await api.post('/Login/VerifyLogin', credentials);
            
        },

        async attempt({ commit, state }, token) {

            if (token) {
                commit('SET_TOKEN', token)
            }

            if (!state.token) {
                return
            }

        },

        async attemptUser({ commit, state }, userDate) {

            if (userDate) {
                commit('SET_USER', userDate)
            }

            if (!state.token) {
                return
            }

        }
    }
};
